module.exports = __webpack_public_path__ + "static/media/placeholder.65181b70.png";